import { Slide } from "react-awesome-reveal";
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Act({ img, name }) {
    return <div className="act-item">
        <div className="overflow-hidden">
            <img className="img-fluid w-100 h-100" src={img} alt="" />
        </div>
        <div className="d-flex align-items-center justify-content-between bg-medium-pink p-4">
            <h5 className="text-truncate me-3 mb-0">{name}</h5>
        </div>
    </div>;
}

function Acts() {
    let duration = 200;
    let delay = 100;
    let fraction = 0.05;
    const [actItems, setActItems] = useState([]);

    useEffect(() => {
        const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/acts`;

        axios.get(apiEndpoint)
            .then(response => setActItems(response.data))
            .catch(error => console.error('Error fetching act items:', error));
    }, []);

    return (
        <div id="acts" className="container-xxl py-5 section">
            <div className="container">
                <h2 className="text-secondary text-uppercase">Numery</h2>
                <div className="acts-grid">
                    {/*<Slide direction="up" cascade triggerOnce delay={delay} duration={duration} fraction={fraction}>*/}
                        {actItems.map((item, index) => (
                            <Act key={index} img={process.env.REACT_APP_API_BASE_URL + "/" + item.pictureUrl} name={item.name} />
                        ))}
                    {/*</Slide>*/}
                </div>
            </div>
        </div>
    );
}

export default Acts;

